import Vue from "vue";
import { helpers } from "vuelidate/lib/validators";
import router from "@/router";
import i18n from "@/core/locales/i18n";
import moment from "moment";
import $ from "jquery";
import { ERROR_CODE } from "@/constants/error-code";
import { CONSTANTS } from "@/constants/common-constant";

const formatDate = "YYYY/MM/DD";
const fieldLengthCheck = "Validation.field_length_check";

/*jshint -W014 */
export default {
  // 各種設定取得
  getVariousSettings(params) {
    return Vue.axios.get("/kyg017001/init?type=" + params);
  },
  //「送り状発行するボタン」押下時
  issueInvoice(params) {
    return Vue.axios.get("/issue-invoice", {
      params: params
    });
  },
  //正確な長さを確認する
  checkExactLength(param, value) {
    if (value && value !== "" && value.length !== param) {
      return false;
    }
    return true;
  },
  //半角数字チェック
  checkHalfNumberic(value) {
    const pattDecimal = /^[0-9]*$/;
    if (!value || value === "" || pattDecimal.test(value)) {
      return true;
    } else {
      return false;
    }
  },
  //半角アルファを確認する
  checkHalfAlphabet(value) {
    const pattDecimal = /^[a-zA-Z]*$/;
    if (!value || value === "" || pattDecimal.test(value)) {
      return true;
    } else {
      return false;
    }
  },
  //半角アルファ数字チェック
  halfAlphaNumberic(value) {
    const pattDecimal = /^[a-zA-Z0-9]*$/;
    if (!value || value === "" || pattDecimal.test(value)) {
      return true;
    } else {
      return false;
    }
  },
  //小数をチェックする
  checkDecimal() {
    return helpers.regex("decimal", /^\d*\.?\d*$/);
  },

  //整数部3桁、小数部1桁以内
  checkDecimal4Digit(value) {
    const pattDecimal = /^(\-)?(\d{1,3})(\.)?(\.\d{1})?$/;
    if (!value || pattDecimal.test(value)) {
      return true;
    } else {
      return false;
    }
  },
  //整数部5桁、小数部1桁以内
  checkDecimal6Digit(value) {
    const pattDecimal = /^(\-)?(\d{1,5})(\.)?(\.\d{1})?$/;
    if (!value || pattDecimal.test(value)) {
      return true;
    } else {
      return false;
    }
  },

  // 10桁
  check10Digit(value) {
    const pattNumber = /^(\-)?(\d{1,10})$/;
    if (!value || pattNumber.test(value)) {
      return true;
    } else {
      return false;
    }
  },

  // 郵便番号
  checkZipcodeUS(country, value, isActive) {
    if (!isActive) {
      return true;
    }
    // お届け先の国がアメリカ又はプエルトリコの場合
    if (country === "US" || country === "PR") {
      if (value && value.length === 5) {
        const patt = /^[0-9]{5}$/;
        return patt.test(value);
      } else if (value && value.length > 5) {
        const patt = /^[0-9]{9}$/;
        return patt.test(value);
      } else {
        return false;
      }
    } else if (country === "CA") {
      // お届け先の国がカナダの場合
      const patt = /^[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9]{1}$/;
      return patt.test(value);
    } else {
      const patt = /^[a-zA-Z0-9]{0,9}$/;
      const result = patt.test(value);
      return result;
    }
  },

  /**
   * ご依頼主.郵便番号チェック
   * ご依頼主.郵便番号に半角数字、半角英字と"-"記号しか無いこと。
   */
  checkPostalCode() {
    return helpers.regex("postalCode", /^[0-9a-zA-Z-]+$/);
  },

  //有償／無償と貨物種別の妥当性チェック
  checkPaidDivRequired(value, cargoType) {
    if (cargoType === "N" && (!value || value === "")) {
      return false;
    } else {
      return true;
    }
  },
  //有償／無償と貨物種別の妥当性チェック
  checkPaidDivValue(value) {
    const values = ["01", "02", "03", "04", "05"];
    if (!value) {
      return true;
    } else if ($.inArray(value, values) === -1) {
      return false;
    } else {
      return true;
    }
  },
  //実重量と正味重量の妥当性チェック
  checkZeroError(value) {
    if (parseFloat(value) <= 0) {
      return false;
    } else {
      return true;
    }
  },
  //ご依頼主・都道府県、ご依頼主・市・区・郡とご依頼主・町・番地・建物名の相関性チェック
  checkPrefectures(prefecture, cityWard, treet) {
    let value = "";
    if (prefecture) {
      value += prefecture;
    }
    if (cityWard) {
      value += cityWard;
    }
    if (treet) {
      value += treet;
    }
    if (value.length > 105) {
      return false;
    } else {
      return true;
    }
  },
  //チェック対象の文字は「記号①」シートを参照。
  checkCharCtrl01(value) {
    const partern = /^[\x20-\x7e\x5b-\x5f]+$/;
    if (!value || partern.test(value)) {
      return true;
    } else {
      return false;
    }
  },
  //チェック対象の文字は「記号②」シートを参照。
  checkCharCtrl02(value) {
    const partern = /^[\x20-\x23\x25-\x5a\x60-\x7e]+$/;
    if (!value || partern.test(value)) {
      return true;
    } else {
      return false;
    }
  },
  gotoErrorPage(wrappedResponse, errorType) {
    if (router.path !== "/errorserver") {
      router.push({
        name: "ErrorServer",
        params: { errorResponse: wrappedResponse, errorType: errorType }
      });
    }
  },
  // 出荷予定日(から)、出荷予定日(まで)の相関性チェック
  checkDateFromTo(fromDate, toDate, value) {
    if (!fromDate || !toDate || !value) {
      return true;
    } else {
      const convFromDate = new Date(fromDate).getTime();
      const convToDate = new Date(toDate).getTime();
      if (convFromDate > convToDate) {
        return false;
      }
      return true;
    }
  },
  checkRangeDate(date) {
    if (!date) {
      return true;
    }
    const rangeDate = this.getRangeDate();
    const upperLimitDate = rangeDate.upperLimitDate;
    const lowerLimitDate = rangeDate.lowerLimitDate;
    if (
      moment(new Date(date)).format("YYYYMMDD") >
        moment(upperLimitDate).format("YYYYMMDD") ||
      moment(new Date(date)).format("YYYYMMDD") <
        moment(lowerLimitDate).format("YYYYMMDD")
    ) {
      return false;
    }
    return true;
  },

  getRangeDate() {
    const rangeDate = {};
    const upperLimitDate = moment(new Date())
      .add(CONSTANTS.ISSUE_DATE_EXPIRATION, "days")
      .format(CONSTANTS.FORMAT_DATE_MONENT);
    const lowerLimitDate = moment(new Date())
      .subtract(CONSTANTS.ISSUE_SEARCH_LOWER_LIMIT, "days")
      .format(CONSTANTS.FORMAT_DATE_MONENT);
    rangeDate["lowerLimitDate"] = lowerLimitDate;
    rangeDate["upperLimitDate"] = upperLimitDate;
    return rangeDate;
  },

  disabledDateForNewIssue(currentDate) {
    return this.disabledDateRange(
      currentDate,
      CONSTANTS.NEW_ISSUE_LOWER_LIMIT,
      CONSTANTS.ISSUE_DATE_EXPIRATION
    );
  },

  disabledDateForSearchIssue(currentDate) {
    return this.disabledDateRange(
      currentDate,
      CONSTANTS.ISSUE_SEARCH_LOWER_LIMIT,
      CONSTANTS.ISSUE_DATE_EXPIRATION
    );
  },

  disabledDateForSearchReIssue(currentDate) {
    return this.disabledDateRange(
      currentDate,
      CONSTANTS.REISSUE_SEARCH_LOWER_LIMIT,
      CONSTANTS.ISSUE_DATE_EXPIRATION
    );
  },

  disabledDateRange(currentDate, lowerLimit, upperLimit) {
    const toDate = new Date();
    toDate.setDate(toDate.getDate() - lowerLimit);
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() + upperLimit);
    return {
      to: toDate,
      from: fromDate,
      currentDate: currentDate
    };
  },

  checkDateLimitTop(date) {
    if (!date) {
      return true;
    }
    const now = new Date();
    const lowerLimitDate = now;
    const upperLimitDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + CONSTANTS.ISSUE_DATE_EXPIRATION + 1
    );
    if (
      moment(new Date(date)).format("YYYYMMDD") <
        moment(lowerLimitDate).format("YYYYMMDD") ||
      moment(new Date(date)).format("YYYYMMDD") >
        moment(upperLimitDate).format("YYYYMMDD")
    ) {
      return false;
    }
    return true;
  },
  convertRangeDate() {
    const convRangeDate = {};
    const rangeDate = this.getRangeDate();
    const limitDate = moment(rangeDate.lowerLimitDate).format(formatDate);
    const upperDate = moment(rangeDate.upperLimitDate).format(formatDate);
    convRangeDate["lowerLimitDate"] = limitDate;
    convRangeDate["upperLimitDate"] = upperDate;
    return convRangeDate;
  },

  //番号を確認する
  isNumber(value) {
    const patt1 = /^[0-9]*\.[0-9]*$/;
    const patt2 = /^[0-9]*$/;
    if (patt1.test(value) || patt2.test(value)) {
      return true;
    } else {
      return false;
    }
  },

  //出荷予定日(から)、出荷予定日(まで)の相関性チェック
  checkFromToDate(fromDate, toDate) {
    if (fromDate && toDate && fromDate > toDate) {
      return false;
    } else {
      return true;
    }
  },
  //check required if control is active
  requiredWithCondition(value, disable) {
    if (value) {
      value = value.trim();
    }
    if (!disable && !value) {
      return false;
    } else {
      return true;
    }
  },
  fieldSorter(fields, direction) {
    const _this = this;
    return function(a, b) {
      return fields
        .map(function(o) {
          return _this.checkDirection(direction, o, a, b);
        })
        .reduce(function firstNonZeroValue(p, n) {
          return p ? p : n;
        }, 0);
    };
  },
  checkDirection(direction, o, a, b) {
    let dir = 1;
    if (o[0] === "-") {
      dir = -1;
      o = o.substring(1);
    }
    // if column first sort ASC
    if (direction === "ASC") {
      if (a[o] > b[o]) {
        return dir;
      }
      if (a[o] < b[o]) {
        return -dir;
      }
    }
    // if column first sort DESC
    if (direction === "DESC") {
      if (a[o] < b[o]) {
        return dir;
      }
      if (a[o] > b[o]) {
        return -dir;
      }
    }
    return 0;
  },
  //validate required with country = US||CA||IE
  requiredState(value, country) {
    if (["US", "CA", "IE"].indexOf(country) !== -1 && !value) {
      return false;
    } else {
      return true;
    }
  },
  //お届け先・州、お届け先・都市とお届け先・住所の相関性チェック
  addressLengthError(stateCd, city, address, listState) {
    let str = "";
    const listStateFilter = listState.find(item => stateCd === item.stateCd);
    if (listStateFilter && listStateFilter.stateName) {
      str += listStateFilter.stateName;
    } else {
      str += "";
    }
    if (city) {
      str += city;
    }
    if (address) {
      str += address;
    }
    if (str.length > 105) {
      return false;
    } else {
      return true;
    }
  },
  //check field length
  fieldLengthCheck(value, max) {
    if (value && value.length > max) {
      return false;
    } else {
      return true;
    }
  },

  checkLengthMinMax(value, countryCd, isActive) {
    if (!value || !isActive) {
      return true;
    }
    if (
      countryCd === "US" ||
      countryCd === "CA" ||
      countryCd === "PR" ||
      countryCd === "VI"
    ) {
      const numberOfDigits = value.replace(/[^0-9]/g, "").length;
      if (numberOfDigits >= 10 && numberOfDigits <= 14) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  },

  checkLengthPostalCodeShipper(value) {
    if (!value) {
      return true;
    }

    const numberOfDigits = value.replace(/[^0-9]/g, "").length;
    if (numberOfDigits <= 9) {
      return true;
    } else {
      return false;
    }
  },

  //代表品目名の妥当性チェック
  itemNameCheck(value, listItem) {
    for (let i = 0; i < listItem.length; i++) {
      if (value === listItem[i].itemName) {
        return true;
      }
    }
    return false;
  },
  //品目情報の品目コードの重複チェック
  checkDupplicate(value, listItems) {
    if (!listItems || !value) {
      return true;
    }
    let count = 0;
    for (let i = 0; i < listItems.length; i++) {
      if (!listItems[i].itemCd) {
        continue;
      }
      if (value.toLowerCase() === listItems[i].itemCd.toLowerCase()) {
        count++;
      }
    }
    if (count >= 2) {
      return false;
    } else {
      return true;
    }
  },
  //validate height
  checkHeight(height, width, length) {
    if (!height && (width || length)) {
      return false;
    } else {
      return true;
    }
  },
  //validate width
  checkWidth(height, width, length) {
    if (!width && (height || length)) {
      return false;
    } else {
      return true;
    }
  },
  //validate length
  checkLength(height, width, length) {
    if (!length && (width || height)) {
      return false;
    } else {
      return true;
    }
  },
  // 日付を文字列yyyymmddにフォーマットする
  customFormatter(dateArg) {
    if (dateArg) {
      const date = moment(dateArg);
      return date.format("YYYYMMDD");
    } else {
      return null;
    }
  },
  // 日付を文字列yyyy/mm/ddにフォーマットする
  customDateDisplay(dateArg) {
    if (dateArg) {
      const date = moment(dateArg);
      if (date.isValid()) {
        return date.format(formatDate);
      }
    }
    return null;
  },
  //・サービス種類 = 03：国際クール宅急便且つクール区分 = nullの場合
  checkCool(value, serviceKbn) {
    if (serviceKbn === "03" && !value) {
      return false;
    } else {
      return true;
    }
  },
  //・クール区分 != 1：冷凍 且つ クール区分 != 2：冷蔵の場合
  checkCoolKbnValue(value) {
    if (value && value !== "1" && value !== "2") {
      return false;
    } else {
      return true;
    }
  },
  //「個数 × 単価」の桁あふれの場合
  checkValueTotalMoney(value, params) {
    if (value && params) {
      const total = parseInt(Number(value) * Number(params));
      if (total) {
        return this.check10Digit(total.toString());
      }
      return true;
    }
    return true;
  },
  //実重量と容積重量の妥当性チェック
  //・サービス種類 = 01：国際宅急便の場合
  //・サービス種類 = 03：国際クール宅急便の場合
  checkOverSize(value, serviceKbn, weightLimit) {
    if (!value || !weightLimit || weightLimit.lenght === 0) {
      return true;
    } else if (
      serviceKbn === "01" &&
      Number(value) > Number(weightLimit[0].stringValue)
    ) {
      return false;
    } else if (
      serviceKbn === "03" &&
      Number(value) > Number(weightLimit[1].stringValue)
    ) {
      return false;
    } else {
      return true;
    }
  },
  //・実重量と正味重量の比較は両方とも0より大きい場合
  checkWeightConflict(value, grossWeight, netWeight) {
    if (!value || !grossWeight || !netWeight) {
      return true;
    } else if (
      Number(grossWeight) > 0 &&
      Number(netWeight) > 0 &&
      Number(grossWeight) < Number(netWeight)
    ) {
      return false;
    } else {
      return true;
    }
  },
  //・サービス種類 = 01：国際宅急便の場合
  //・サービス種類 = 03：国際クール宅急便の場合
  checkOverSizeDemension(value, serviceKbn, height, width, length, sizeLimit) {
    if (this.checkNullOrUndefined(value, height, width, length, sizeLimit)) {
      return true;
    }
    const total = Number(height) + Number(width) + Number(length);
    if (serviceKbn === "01" && total > Number(sizeLimit[0].stringValue)) {
      return false;
    } else if (
      serviceKbn === "03" &&
      total > Number(sizeLimit[1].stringValue)
    ) {
      return false;
    } else {
      return true;
    }
  },
  checkNullOrUndefined(value, height, width, length, sizeLimit) {
    if (!value || !sizeLimit || sizeLimit.length === 0) {
      return true;
    }
    if (!height || !width || !length) {
      return true;
    }
    return false;
  },
  checkRequiredCity(value, cityDisplay) {
    if (cityDisplay && !value) {
      return false;
    } else {
      return true;
    }
  },
  // 「TaxIDプルダウン」選択時に入力エリア表示
  changeTaxIdTextDisplay(usciOcKbn) {
    if (!usciOcKbn || usciOcKbn === "") {
      return false;
    } else {
      return true;
    }
  },
  // 送り状画面の表示項目を設定する - TaxID - 必須ラベル
  changeTaxIdRequiredDisplay(listTaxIdInfo) {
      if (listTaxIdInfo[0].requiredFlg === "1") {
        return true;
      }
    return false;
  },
  // インボイス画面の表示項目を設定する - TaxID - 必須ラベル
  changeTaxIdInvRequiredDisplay(country, listTaxId) {
    let listTaxIdInfoRequired = [];
    // リストが存在するかチェック
    if (!listTaxId) {
      return false;
    }
    // お届け先区分「法人」を格納する変数
    let hasCorporation = false;
    // お届け先区分「個人」を格納する変数
    let hasPersonal = false;
    for (let i = 0; i < listTaxId.length; i++) {
      const item = listTaxId[i];
      if (item.countryCd === country){
        const internalCd = item.taxIdInternalCd;
            // internalCdが存在し、空でないことを確認
            if (internalCd && internalCd.length > 0) {
                // 先頭の文字を数値に変換
                const firstDigit = parseInt(internalCd[0], 10);
                if (firstDigit >= 0 && firstDigit <= 4) {
                  hasCorporation = true;
                } else if (firstDigit >= 5 && firstDigit <= 9) {
                  hasPersonal = true;
                }
            }
        listTaxIdInfoRequired.push(String(item.requiredFlg));
      }
    }
    // 絞り込んだ結果、必須項目がない場合、falseを返す
    if (listTaxIdInfoRequired.length === 0) {
      return false;
    }
    // 法人、個人が存在する かつ 絞り込んだリストのすべての要素が "1" である場合、trueを返す
    // 条件にあてはまらない場合、falseを返す
    if (listTaxIdInfoRequired.every(flag => flag === '1') && hasCorporation && hasPersonal){
      return true;
    }
  },
  // 送り状「画面.お届け先.TaxID番号（入力エリア）」フィールドに最大長を設定する（値が存在しない場合30を返す）
  changeTaxIdTextMaxlength(countryCd, consigneeDiv, usciOcKbn, listTaxIdInfo) {
    let maxLength =
      listTaxIdInfo.find(
        tax =>
          countryCd === tax.countryCd &&
          consigneeDiv === tax.consigneeDiv &&
          usciOcKbn === tax.taxIdInternalCd
      )?.digit ?? 30;
    return maxLength;
  },
    // インボイス「画面.お届け先.TaxID番号（入力エリア）」フィールドに最大長を設定する（値が存在しない場合30を返す）
  changeTaxIdInvTextMaxlength(countryCd, usciOcKbn, listTaxIdMaxlength) {
    let maxLength =
      listTaxIdMaxlength.find(
        tax => countryCd === tax.countryCd && usciOcKbn === tax.taxIdInternalCd
      )?.digit ?? 30;
    return maxLength;
  },
  getErrorMessageApi(paramErrorMessageApi) {
    const keyItemCommon = [
      "consigneeInfo",
      "shipperInfo",
      "referenceNo",
      "consigneePhone",
      "consigneeZip",
      "consigneeCountryCd",
      "consigneeCityCd",
      "consigneeUsciOcDiv",
      "consigneeUsciOcCd",
      "stateCd",
      "consigneeAddress1",
      "consigneeAddress2",
      "consigneeAddress3",
      "consigneeAddress4",
      "consigneeName",
      "shipperOrganizationCd",
      "shipperPhone",
      "shipperZip",
      "shipperAddress1",
      "shipperAddress2",
      "shipperAddress3",
      "shipperAddress4",
      "shipperName"
    ];
    const errorDetail = paramErrorMessageApi.error.detail;
    const errorMap = new Map();
    Object.keys(errorDetail).forEach(key => {
      const field = errorDetail[key].Field;
      let subField = field;
      let message = errorDetail[key].ValidationMessage;

      if (field.indexOf(".") !== -1) {
        if (field.indexOf("billingInfo") !== -1) {
          subField = "billingInfo";
        } else {
          subField = field.substring(field.lastIndexOf(".") + 1, field.length);
        }
      }

      message = this.getItemError1(
        subField,
        message,
        field,
        paramErrorMessageApi,
        keyItemCommon
      );

      if (field.indexOf("itemInfo[") !== -1) {
        subField = field.substring(field.indexOf("itemInfo["));
      }
      errorMap.set(subField, message);
    });
    return errorMap;
  },
  getItemError1(subField, message, field, paramErrorMessageApi, keyItemCommon) {
    const functionId = paramErrorMessageApi.functionId;
    const invoiceFlg = paramErrorMessageApi.invoiceFlg;
    const paramMessageInvoice = "ParamMessage.invoice.";
    const paramMessageShipment = "ParamMessage.shipment.";
    if (functionId && keyItemCommon.indexOf(subField) !== -1 && invoiceFlg) {
      message = message.replace(
        field,
        i18n.t(functionId + "." + paramMessageInvoice + subField)
      );
    } else if (
      functionId &&
      keyItemCommon.indexOf(subField) !== -1 &&
      !invoiceFlg
    ) {
      message = message.replace(
        field,
        i18n.t(functionId + "." + paramMessageShipment + subField)
      );
    } else {
      message = this.getItemError2(
        subField,
        message,
        field,
        paramErrorMessageApi,
        keyItemCommon
      );
    }
    return message;
  },
  getItemError2(subField, message, field, paramErrorMessageApi, keyItemCommon) {
    const functionId = paramErrorMessageApi.functionId;
    const invoiceFlg = paramErrorMessageApi.invoiceFlg;
    const paramMessageInvoice = "ParamMessage.invoice.";
    const paramMessageShipment = "ParamMessage.shipment.";
    if (functionId && keyItemCommon.indexOf(subField) === -1) {
      message = message.replace(
        field,
        i18n.t(functionId + "." + "ParamMessage." + subField)
      );
    } else if (
      !functionId &&
      keyItemCommon.indexOf(subField) !== -1 &&
      invoiceFlg
    ) {
      message = message.replace(field, i18n.t(paramMessageInvoice + subField));
    } else if (
      !functionId &&
      keyItemCommon.indexOf(subField) !== -1 &&
      !invoiceFlg
    ) {
      message = message.replace(field, i18n.t(paramMessageShipment + subField));
    } else {
      message = message.replace(field, i18n.t("ParamMessage." + subField));
    }

    return message;
  },
  closeModal(bvModal, modalId) {
    document
      .querySelector("div[id^='" + modalId + "']")
      .setAttribute("style", "display:none");
    bvModal.hide(modalId);
  },
  getErrorMessage(errorItem) {
    let message = this.getMessageErrorNotNull(errorItem);

    if (!message) {
      message = this.getMessageErrorSingleItem(errorItem);
    }

    if (!message) {
      message = this.getMessageErrorHalfSize(errorItem);
    }

    if (!message) {
      message = this.getMessageErrorLengthAndCool(errorItem);
    }

    if (!message) {
      message = this.getMessageErrorRelatedItems(errorItem);
    }

    if (!message) {
      message = this.getMessageErrorNumber(errorItem);
    }

    if (!message) {
      message = this.getMessageErrorDigit(errorItem);
    }

    return message;
  },

  getMessageErrorNotNull(errorItem) {
    switch (false) {
      case errorItem.validate.required:
      case errorItem.validate.requiredWithCondition:
      case errorItem.validate.checkPaidDivRequired:
      case errorItem.validate.checkLength:
      case errorItem.validate.checkWidth:
      case errorItem.validate.checkHeight:
      case errorItem.validate.requiredState:
      case errorItem.validate.checkCool:
      case errorItem.validate.checkRequiredCity:
        return this.showMessageNotnull(errorItem);
      default:
        return "";
    }
  },

  showMessageNotnull(errorItem) {
    if (errorItem.msgNotNull) {
      return i18n.t("Validation.not_null", { 0: errorItem.itemName });
    } else {
      return i18n.t("Validation.InputRequired", { 0: errorItem.itemName });
    }
  },

  getMessageErrorSingleItem(errorItem) {
    switch (false) {
      case this.isSize(errorItem):
        return i18n.t("Validation.sizeHsCd", {
          0: errorItem.itemName,
          min: errorItem.minValue,
          max: errorItem.maxValue,
          1: errorItem.value
        });
      case errorItem.validate.exactLength:
        return i18n.t("Validation.exact_match", { 0: errorItem.maxDigit });
      case this.isDigit(errorItem):
        return i18n.t("Validation.digits");
      case errorItem.validate.isDate:
        return i18n.t("Validation.date", { 0: errorItem.itemName });
      case errorItem.validate.between:
        return i18n.t("Validation.range", {
          min: errorItem.minValue,
          max: errorItem.validate.$params.between.max
        });
      default:
        return "";
    }
  },

  getMessageErrorHalfSize(errorItem) {
    switch (false) {
      case errorItem.validate.halfNumberic:
      case errorItem.validate.numeric:
      case errorItem.validate.decimal:
      case errorItem.validate.checkDecimal:
        return i18n.t("Validation.halfSize", {
          0: errorItem.itemName,
          1: errorItem.value
        });
      case errorItem.validate.halfAlphaNumberic:
      case errorItem.validate.alphaNum:
      case errorItem.validate.halfAlphabet:
        return i18n.t("Validation.AlphabetMismatch", {
          0: errorItem.itemName,
          1: errorItem.value
        });
      case errorItem.validate.checkDateLimitTop:
        return i18n.t("Validation.ShippingDateTopLimitError", {
          0: errorItem.itemName,
          1: errorItem.value
        });
      case errorItem.validate.checkPackageCount:
        return i18n.t("Validation.PackageCountError", {
          0: i18n.t("ParamMessage.pcs"),
          1: errorItem.value
        });
      default:
        return "";
    }
  },

  getMessageErrorLengthAndCool(errorItem) {
    let errorMsg = "";
    errorMsg = this.getMessageErrorForLength(errorItem);
    if (!errorMsg) {
      errorMsg = this.getMessageErrorForInputInvalid(errorItem);
    }
    return errorMsg;
  },

  getMessageErrorForInputInvalid(errorItem) {
    switch (false) {
      case errorItem.validate.checkPostalCode:
      case errorItem.validate.checkZipcodeUS:
      case errorItem.validate.checkPaidDivValue:
      case errorItem.validate.checkCoolKbnValue:
      case errorItem.validate.checkVatRegisterDivValid:
        return i18n.t("Validation.inputNotValid", {
          0: errorItem.itemName,
          1: errorItem.value
        });
      case errorItem.validate.checkDecimal4Digit:
        return i18n.t(fieldLengthCheck, {
          0: errorItem.itemName,
          1: i18n.t("ParamMessage.decimal4"),
          2: errorItem.value
        });
      case errorItem.validate.checkDecimal6Digit:
        return i18n.t(fieldLengthCheck, {
          0: errorItem.itemName,
          1: i18n.t("ParamMessage.decimal6"),
          2: errorItem.value
        });
      default:
        return "";
    }
  },

  getMessageErrorForLength(errorItem) {
    switch (false) {
      case errorItem.validate.fieldLengthCheck:
        return i18n.t(fieldLengthCheck, {
          0: errorItem.itemName,
          1: errorItem.maxDigit,
          2: errorItem.value
        });
      case errorItem.validate.checkLengthPostalCodeShipper:
        return i18n.t("Validation.sizePostalCode", {
          min: errorItem.minValue
        });
      default:
        return "";
    }
  },

  getMessageErrorRelatedItems(errorItem) {
    switch (false) {
      case errorItem.validate.checkCharCtrl01:
      case errorItem.validate.checkCharCtrl02:
        return i18n.t("Validation.notValid", {
          0: errorItem.itemName,
          1: errorItem.value
        });
      case errorItem.validate.checkLengthMinMax:
        return i18n.t("Validation.sizePhone", {
          min: errorItem.minValue
        });
      case errorItem.validate.itemCodeCheck:
        return i18n.t("Validation.LimitCodeError");
      case errorItem.validate.checkRangeDate:
        return i18n.t("Validation.ShippingDateRangeError", {
          0: errorItem.itemName,
          1: errorItem.rangeDate.lowerLimitDate,
          2: errorItem.rangeDate.upperLimitDate,
          3: errorItem.value
        });
      case errorItem.validate.checkOverSize:
      case errorItem.validate.checkOverSizeDemension:
        return i18n.t("Validation.OverSize", { 0: errorItem.overSizeLabel });
      case errorItem.validate.checkWeightConflict:
        return i18n.t("Validation.WeightConflict");
      case errorItem.validate.checkDuplicateReferenceNo:
        return i18n.t("Validation.InvoiceNoExistError", { 0: errorItem.value });
      default:
        return "";
    }
  },
  getMessageErrorNumber(errorItem) {
    switch (false) {
      case errorItem.validate.zeroError:
        return i18n.t("Validation.ZeroError", {
          0: errorItem.zeroLable ? errorItem.zeroLable : errorItem.itemName,
          1: errorItem.value
        });
      case errorItem.validate.checkValueTotalMoney:
      case errorItem.validate.checkTotalPrice:
        return i18n.t("Validation.TotalMoneyError", {
          0: i18n.t("ParamMessage.TotalMoneyError")
        });
      case errorItem.validate.LengthErrorPrefectures:
      case errorItem.validate.LengthErrorCity:
      case errorItem.validate.LengthErrorStreet:
        return i18n.t("Validation.ShipperAddressLengthError");

      default:
        return "";
    }
  },

  getMessageErrorDigit(errorItem) {
    switch (false) {
      case errorItem.validate.addressLengthErrorState:
      case errorItem.validate.addressLengthErrorAddress:
      case errorItem.validate.addressLengthErrorCity:
        return i18n.t("Validation.AddressLengthError");
      case errorItem.validate.checkFromDate:
      case errorItem.validate.checkToDate:
        return i18n.t("Validation.FieldDateFromToCheck");
      case errorItem.validate.checkDupplicate:
        return i18n.t("Validation.ItemDuplicateError");
      default:
        return "";
    }
  },

  isDigit(errorItem) {
    if (
      (errorItem.validate.integer === undefined &&
        errorItem.validate.decimalValue === undefined) ||
      errorItem.validate.integer ||
      errorItem.validate.decimalValue
    ) {
      return true;
    } else {
      return false;
    }
  },
  isSize(errorItem) {
    return errorItem.validate.minLength && errorItem.validate.maxLength;
  },
  checkPackageCount(value) {
    if (value && (value < 1 || value > 200)) {
      return false;
    }

    return true;
  },
  scrollToItem(elementId, modalId) {
    let element = $("html, body");
    if (modalId) {
      element = $("#" + modalId);
    }
    element.animate(
      {
        scrollTop: document.getElementById(elementId).offsetTop
      },
      500
    );
  },
  freezeTable(containerId) {
    Vue.nextTick(function() {
      $("#" + containerId + " tbody").scroll(function() {
        //fix the thead relative to the body scrolling
        $("#" + containerId + " thead").css(
          "left",
          -$("#" + containerId + " tbody").scrollLeft()
        );
      });
    });
  },
  scrollTableToLeft(containerId) {
    const $root = $(`#${containerId} tbody`);
    if ($root.scrollLeft() > 0) {
      $root.animate({ scrollLeft: 0 }, 500);
    }
  },
  scrollTableToRight(containerId) {
    const query = `#${containerId} tbody`;
    const element = document.querySelector(query);
    const scrollWidth = element.scrollWidth - element.clientWidth;
    if ($(query).scrollLeft() < scrollWidth) {
      $(query).animate({ scrollLeft: scrollWidth }, 500);
    }
  },
  // サービス一覧を取得する
  getListService(listService, coolOfferKbn) {
    let data = [];
    if (listService) {
      data = listService.filter(
        item => item.sbtNaiID === "01" || item.sbtNaiID === "03"
      );
      for (let i = 0; i < data.length; i++) {
        if (data[i].sbtNaiID === "03" && coolOfferKbn === "00") {
          data.splice(i, 1);
        }
      }
    }
    return data;
  },
  // ワーク.汎用マスタリスト
  getItemInfo(id, data) {
    if (!data.queriedItemsInfo) {
      return [];
    } else {
      const queriedItemsInfo = data.queriedItemsInfo;
      if (queriedItemsInfo && queriedItemsInfo.length > 0) {
        return this.findItemInfos(queriedItemsInfo, id);
      } else {
        return [];
      }
    }
  },
  findItemInfos(queriedItemsInfo, id) {
    for (let i = 0; i < queriedItemsInfo.length; i++) {
      if (queriedItemsInfo[i].sbtID === id && queriedItemsInfo[i].sbtIDList) {
        return queriedItemsInfo[i].sbtIDList;
      }
    }
    return [];
  },
  getValueCheckUndefined(value) {
    return value ? value : null;
  },
  checkDuplicateReferenceNo(value, listDuplicate) {
    if (!listDuplicate || listDuplicate.length === 0) {
      return true;
    }
    const data = value ? value.trim() : value;
    for (let i = 0; i < listDuplicate.length; i++) {
      const referenceNoCheck = listDuplicate[i]
        ? listDuplicate[i].trim()
        : listDuplicate[i];
      if (data === referenceNoCheck) {
        return false;
      }
    }
    return true;
  },
  animateScroll(id, offset) {
    const $root = $(id);
    if ($root.scrollTop() > offset) {
      $root.animate({ scrollTop: offset }, 500);
    }
  },
  trimValue(value) {
    return value ? value.trim() : value;
  },
  /*
   * Remove keys from object
   *   const removeKeys = ["searchDiv", "serviceDiv", "shippingDateFrom"];
   *   dataPost = CommonService.mapOut(dataPost, removeKeys);
   * */
  mapOut(sourceObject, removeKeys = []) {
    let returnObject = {};
    if (Array.isArray(sourceObject)) {
      returnObject = sourceObject.map(obj => this.mapOut(obj, removeKeys));
      return returnObject;
    }

    const sourceKeys = Object.keys(sourceObject);
    const returnKeys = sourceKeys.filter(k => !removeKeys.includes(k));

    returnKeys.forEach(k => {
      if (Array.isArray(sourceObject[k])) {
        returnObject[k] = sourceObject[k].map(obj =>
          this.mapOut(obj, removeKeys)
        );
      }
      if (typeof sourceObject[k] == "object" && sourceObject[k] !== null) {
        returnObject[k] = this.mapOut(sourceObject[k], removeKeys);
      } else {
        returnObject[k] = sourceObject[k];
      }
    });
    return returnObject;
  },
  getErrorMessageUps(errorData) {
    let message = "";
    const errorCode = errorData.errorCodeUPS;
    if (errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_REISSUE) > -1) {
      message = i18n.t("Message.ReissueError", {
        0: this.getReferenceNo(errorData.listUpsError)
      });
      return message;
    }

    if (errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_INPUT_MISMATCH) > -1) {
      message = i18n.t("Message.InputMismatch", {
        0: i18n.t("ParamMessage.deliveryPostalCode"),
        1: i18n.t("ParamMessage.stateName")
      });
    }

    if (
      errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_LOCATION_NOT_SUPPORT) > -1
    ) {
      if (message) {
        message += "\n";
      }
      message += i18n.t("Message.LocationNotSupport");
    }

    if (
      errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_CONSIGNEE_ZIP_NOT_EXIST) >
      -1
    ) {
      if (message) {
        message += "\n";
      }
      message += i18n.t("Message.ConsigneeZipNotExist");
    }
    if (
      errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_VAT_REGISTER_NUMBER) > -1
    ) {
      if (message) {
        message += "\n";
      }
      message += i18n.t("Message.VatRegisterNumberError");
    }
	if (
      errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_PAYMENT_DIV_NOT_SUPPORT) > -1
    ) {
      if (message) {
        message += "\n";
      }
      message += i18n.t("Message.PaymentDivNotSupport");
    }
    if (
      errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_HANDWRITE_ONLY) > -1
    ) {
      if (message) {
        message += "\n";
      }
      message += i18n.t("Message.HandwriteOnly");
    }
    if (
      errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_MISSING_SKU) > -1
    ) {
      if (message) {
        message += "\n";
      }
      message += i18n.t("Message.MissingSku");
    }
    if (
      errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_MISSING_MPN) > -1
    ) {
      if (message) {
        message += "\n";
      }
      message += i18n.t("Message.MissingMpn");
    }
    if (
      errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_MISSING_PID) > -1
    ) {
      if (message) {
        message += "\n";
      }
      message += i18n.t("Message.MissingPid");
    }
    if (
      errorCode.indexOf(ERROR_CODE.UPS_API_CALL_ERROR_MISSING_CCEI) > -1
    ) {
      if (message) {
        message += "\n";
      }
      message += i18n.t("Message.MissingCcei");
    }
    return message;
  },
  getReferenceNo(listUpsError) {
    const referenceNoList = [];
    listUpsError.forEach(element => {
      referenceNoList.push(element.referenceNo);
    });
    return referenceNoList.join(", ");
  },
  showDialogOk(bvModal, createElement, contentDialog) {
    const message = contentDialog.replace(/\n/g, "<br>");
    const messageVNode = createElement("span", {
      domProps: { innerHTML: message }
    });
    return bvModal.msgBoxOk(messageVNode, {
      title: "ワールドポータルのメッセージ",
      headerClass: "border-bottom-0",
      footerClass: "border-top-0",
      contentClass: "backgound-color-white",
      buttonSize: "lg",
      noCloseOnEsc: true,
      noCloseOnBackdrop: true
    });
  },
  showDialogConfirm(bvModal, createElement, contentDialog) {
    const message = contentDialog.replace(/\n/g, "<br>");
    const messageVNode = createElement("span", {
      domProps: { innerHTML: message }
    });
    return bvModal.msgBoxConfirm(messageVNode, {
      title: "ワールドポータルのメッセージ",
      headerClass: "border-bottom-0",
      footerClass: "border-top-0",
      contentClass: "backgound-color-white",
      buttonSize: "lg",
      okVariant: "primary",
      okTitle: "OK",
      cancelVariant: "light",
      cancelTitle: "キャンセル",
      noCloseOnEsc: true,
      noCloseOnBackdrop: true
    });
  },
  // フォーマット番号
  formatNumber(val) {
    if (val) {
      let newValue = parseInt(val.toString().replace(/[^\d.]/g, ""));
      if (isNaN(newValue)) {
        newValue = val;
      } else {
        newValue = Math.round(newValue * 100) / 100;
      }
      if (newValue) {
        return newValue
          .toString()
          .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      }
    }
    return "";
  },
  removeKeyStartsWith(map, letter) {
    map.forEach(function(value, key) {
      if (key.match("^" + letter)) {
        map.delete(key);
      }
    });
  }
};
